export enum OrderListRowAction {
  MOVE_TO_PACKED = 'move-to-packed',
  VIEW_BASKET_PHOTO = 'view-basket-photo',
  PRIORITIZE_TASK = 'prioritize-task',
  UNPRIORITIZE_TASK = 'unprioritize-task',
  NO_PICK_CANCEL = 'no-pick-cancel',
  RETRY = 'retry',
  SYNC_AWB = 'sync-awb',
}
